import { IconCircleFilled } from '@tabler/icons-react';
import { daysLeftFromYmd, toYmdDateOnly } from './visaDateUrgency';

/** @param {object|null|undefined} userRow */
export function resolveVisaExpiryYmd(userRow) {
  if (!userRow) return '';
  const raw = userRow.visa_expiry_date ?? userRow.visa_expire_date ?? null;
  return toYmdDateOnly(raw);
}

/**
 * Header badge: show only when 0–90 days left or expired.
 * @param {string} ymd
 * @param {(key: string, fallback?: string) => string} t
 * @returns {{ kind: 'urgent'|'warn', text: string, Icon: import('@tabler/icons-react').Icon, iconColor: string }|null}
 */
export function getVisaHeaderBadge(ymd, t) {
  const dateOnly = toYmdDateOnly(ymd);
  if (!dateOnly) return null;

  const daysLeft = daysLeftFromYmd(dateOnly);
  if (daysLeft == null) return null;

  if (daysLeft < 0) {
    const expiredLabel = t('header.visaExpired', '비자 만료');
    return {
      kind: 'urgent',
      text: expiredLabel,
      Icon: IconCircleFilled,
      iconColor: '#EF4444',
    };
  }

  if (daysLeft > 90) return null;

  const ddayLabel = (t('header.visaDday', '비자 D-{n}') || '비자 D-{n}').replace('{n}', String(daysLeft));
  if (daysLeft <= 30) {
    return {
      kind: 'urgent',
      text: ddayLabel,
      Icon: IconCircleFilled,
      iconColor: '#EF4444',
    };
  }

  return {
    kind: 'warn',
    text: ddayLabel,
    Icon: IconCircleFilled,
    iconColor: '#F59E0B',
  };
}
